import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { ProductCategoryData } from '@/common/types/productCategory.type'
import { PublicCompanyLeadsFunnelContractProductCategoryValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { transformNewContractProductCategory } from '@/features/publicCompanyLeadsFunnel/services/publicCompanyLeadProductCategoryTransformers'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { PublicCompanyLeadData } from '../types/publicCompanyLead'

interface UseCreatePublicCompanyLeadContractProduct {
  publicCompanyLead?: PublicCompanyLeadData
  productCategory?: ProductCategoryData
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useCreatePublicCompanyLeadContractProduct = ({
  publicCompanyLead,
  onSuccess,
  onError,
}: UseCreatePublicCompanyLeadContractProduct) => {
  const publicAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPublicCompanyLeadContractProduct'],
    mutationFn: async (data: PublicCompanyLeadsFunnelContractProductCategoryValidationSchema) => {
      const contract = {
        contract_product_categories_attributes: [
          transformNewContractProductCategory(data, publicCompanyLead?.contract?.contract_product_categories || []),
        ],
      }

      return await publicAxios.put(`/funnel/public/leads/${publicCompanyLead?.id}/update_contract_products`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
